import React, {Component} from 'react';
import styles from './EventListItem.module.css';
import CanceledEventIcon from '../svgs/CanceledEventIcon';
import {
  displayFullAddress,
  localizeTime,
} from '../../../../shared/utils/Helpers';
import AttendeesAndFollowedUsers from '../AttendeesAndFollowedUsers';
import moment from 'moment';
import {projectConfig} from '../../../../shared/project-info/projectConfig';

export default class EventListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventAttendees: [],
      totalAttendees: 0,
    };
  }

  componentDidMount() {
    if (
      this.props.type === 'MyActivities' ||
      this.props.type === 'AllActivities'
    ) {
      this.props.loadAttendees(this.props.event.id).then((res) => {
        let data = [];
        res.going.attendees.map((attendee, i) => data.push(attendee));
        res.interested.attendees.map((attendee, i) => data.push(attendee));
        res.checked_in.attendees.map((attendee, i) => data.push(attendee));
        const totalAttendees =
          res.checked_in.count + res.interested.count + res.going.count;
        this.setState({eventAttendees: data, totalAttendees});
      });
    }
  }

  render() {
    const {
      start,
      end,
      name,
      chapter_name,
      location,
      followingAttendees,
      attendees_count,
      status,
      time_zone_id,
      is_virtual,
    } = this.props.event;
    const {eventAttendees} = this.state;
    const utcStartDateTime = moment.utc(start);
    const utcEndDateTime = moment.utc(end);
    const today = moment();
    const h1Class = projectConfig.useEmphasisFonts ? 'emphasis' : 'normal';
    return (
      <div className={styles.container}>
        <div className={styles.dateContainer}>
          <p className="formLabel" style={{margin: '0', padding: '0'}}>
            {moment(utcStartDateTime).local().isSame(today, 'day')
              ? 'Today'
              : moment(utcStartDateTime).local().format('ddd')}
          </p>
          <p className="date">
            {moment(utcStartDateTime).local().format('DD')}
          </p>
          <p className="formLabel">
            {moment(utcStartDateTime).local().format('MMM')}
          </p>
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.titleContainer}>
            <h1 className={h1Class}>{name}</h1>
            <h5>{chapter_name || ''}</h5>
          </div>
          {status === 'Canceled' && (
            <div className={styles.canceledEventWrapper}>
              <h3 className={styles.canceledEvent}>Canceled</h3>
              <CanceledEventIcon />
            </div>
          )}
          <p className="bodyCopyForm">
            {!this.props.event.is_all_day
              ? `${moment(utcStartDateTime).local().format('h:mm A')}–${moment(
                  utcEndDateTime,
                )
                  .local()
                  .format('h:mm A')}`
              : 'All Day Event'}
          </p>
          {location.address && (
            <p className="bodyCopyForm">
              {displayFullAddress(
                location.address,
                location.city,
                location.state,
                location.zip,
                location.country,
              )}
            </p>
          )}
          <AttendeesAndFollowedUsers
            attendees={eventAttendees}
            followingAttendees={followingAttendees}
            attendeesCount={this.state.totalAttendees}
            maxAttendees={this.state.maxAttendees}
          />
        </div>
      </div>
    );
  }
}
